import { Box, BoxPosition } from '../../generated/model/models'
export interface BoxValue {
  x: number
  y: number
  rotation: number
  position: number
}

export const MARGIN = 1

export const topSide = (box: BoxValue | BoxPosition, template: Box): number => {
  return box.y! - (box.rotation! % 180 === 0 ? (template.width!) / 2 : (template.length! / 2)) + MARGIN
}

export const bottomSide = (box: BoxValue | BoxPosition, template: Box): number => {
  return box.y! + (box.rotation! % 180 === 0 ? (template.width!) / 2 : (template.length! / 2)) - MARGIN
}

export const leftSide = (box: BoxValue | BoxPosition, template: Box): number => {
  return box.x! - (box.rotation! % 180 === 0 ? (template.length!) / 2 : (template.width! / 2)) + MARGIN
}

export const rightSide = (box: BoxValue | BoxPosition, template: Box): number => {
  return box.x! + (box.rotation! % 180 === 0 ? (template.length!) / 2 : (template.width! / 2)) - MARGIN
}

